import type { ChangelogEntry } from "../types";

/**
 * VIB-2775. Hjelp-skallet fra prototypen.
 *
 * Ingen rollekrav: hjelpe-senteret er åpent for alle roller, eksterne
 * inkludert, og hele endringen er noe alle ser første gang de åpner Hjelp.
 */
export const HJELP_SKALL_2026_10: ChangelogEntry = {
  id: "2026-10-05-hjelp-skall",
  date: "2026-10-05",
  title: "Hjelp har fått faner, og endringsloggen er blitt lesbar",
  summary:
    "Fire faner har erstattet den lange venstremenyen, og «Nytt i Revehiet» viser én linje per oppdatering i stedet for alt på én gang.",
  sections: [
    {
      heading: "Hjelp",
      items: [
        {
          title: "Fire faner i stedet for en lang meny",
          kind: "forbedret",
          body: "Øverst står nå Oversikt, Nytt i Revehiet, Alle veiledninger og Dokumentarkiv. Før lå alle veiledningene i en meny langs venstre side som bare ble lengre for hver veiledning vi skrev. Nå har de fått sin egen fane, og fane-raden holder seg like kort uansett hvor mye som kommer til.",
        },
        {
          title: "Oversikten viser det folk faktisk leter etter",
          kind: "forbedret",
          body: "Forsiden i Hjelp starter med de fire oppgavene folk oftest slår opp, og et kort som peker til siste oppdatering. Begynner du å søke eller filtrere, bytter den til trefflista. Før møtte du alle veiledningene på én gang, uansett hva du var ute etter.",
        },
        {
          title: "Endringsloggen er én linje per oppdatering",
          kind: "forbedret",
          body: "Hver oppdatering viser dato, hva slags endring det er, tittel og en kort oppsummering. Punktene kommer når du trykker «Se hva som er endret». Søker du, folder treffene seg ut av seg selv. Før sto alt utbrettet, og lista ble en vegg av tekst der det var vanskelig å se hvor mange oppdateringer som fantes.",
        },
        {
          title: "Veien videre fra endringsloggen",
          kind: "nytt",
          body: "Ved siden av loggen ligger snarveier til de vanligste veiledningene. Har noe endret seg, er neste spørsmål som regel hvordan du gjør det nå, og da slipper du å lete deg tilbake.",
        },
        {
          title: "Søkefeltet i hjelp-menyen er borte",
          kind: "forbedret",
          body: "Det lå i menyen som nå er fjernet. Søket finnes i stedet på hver fane, og leter i samme innhold som før: hele teksten i veiledningene, ikke bare titlene.",
        },
      ],
    },
  ],
};
